/* homepage.js */

document.addEventListener("DOMContentLoaded", function () {

    // Rozbalování sekcí
    document.querySelectorAll(".homepage__section-header").forEach((title) => {
        title.addEventListener("click", function () {
            const content = this.closest(".homepage__section");
            if (content) {
                content.classList.toggle("is-active");
            }
        });
        title.addEventListener("keydown", function(event) {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                const content = this.closest(".homepage__section");
                if (content) {
                    content.classList.toggle("is-active");
                }
            }
        });
    });

    // Swiper reference
    new Swiper('.homepage__section-content-reference-swiper-container', {
        loop: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.homepage__section-content-reference-swiper-nav-next', // Odkaz na tlačítko "next"
            prevEl: '.homepage__section-content-reference-swiper-nav-prev', // Odkaz na tlačítko "prev"
        },
    });
});
